export default `
  mutation createProject($name: String!, $organisationId: String!) {
    createProject(name: $name, organisationId: $organisationId) {
      createProjectFunction {
        id
        name
        organisationId
        createdAt
        organisation {
          id
          name
          userId
          user {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`
